import { Pipe, PipeTransform } from '@angular/core';

import { ICredit } from '../../../../../lib/lib-shared/models/Credit';

@Pipe({
  name: 'isCreditCancelled'
})
export class IsCreditCancelledPipe implements PipeTransform {
  transform(credit: ICredit & {childrenList: ICredit[]}): boolean {
    return !!credit.cancelledAt || credit.childrenList.some(c => !!c.cancelledAt);
  }
}
